module.exports = __webpack_public_path__ + "img/culture01.d326be28.jpg";